"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
    width: "12px",
    height: "16px",
    viewBox: "0 0 12 16"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Audiences",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Group-3",
    transform: "translate(-22.000000, -289.000000)",
    fill: props.fill
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Group-8",
    transform: "translate(20.000000, 288.000000)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.99661596,17 C7.77306088,16.7334134 7.55525009,16.478062 7.34259341,16.2193329 C5.97623986,14.5567754 4.71887038,12.8311089 3.6464591,10.9986016 C3.05164993,9.98228019 2.53226403,8.93374653 2.21613149,7.8198995 C1.69776856,5.99364974 2.11131792,4.3375987 3.46224846,2.89021621 C4.36103274,1.92729745 5.50930009,1.32603765 6.8753389,1.10051633 C8.6224679,0.811992693 10.2300028,1.14215049 11.6465599,2.12273977 C12.8924801,2.98532413 13.6504114,4.12882349 13.9180715,5.5278165 C14.093351,6.44391017 13.9778357,7.33863567 13.6626475,8.22280152 C13.093845,9.81858791 12.2355461,11.2866275 11.2810894,12.7136373 C10.3008622,14.1791881 9.2178279,15.5811677 8.05921296,16.9357533 C8.04351453,16.9540993 8.02529806,16.9707032 7.99661596,17 L7.99661596,17 Z M10.3076921,7.11922952 C10.3082489,5.81387306 9.28529124,4.76878668 8.00310636,4.76471749 C6.7306657,4.76067985 5.70133564,5.81034013 5.69236477,7.10673807 C5.6834867,8.38834184 6.71142473,9.4718489 7.99855906,9.47058713 C9.27678438,9.46932537 10.3071662,8.42177855 10.3076921,7.11922952 L10.3076921,7.11922952 Z",
    id: "Location"
  })))));
};

exports["default"] = _default;